/**
 * Module dependencies.
 */

import { FavoriteProps } from 'src/types/my-products';
import { Token } from 'src/core/utils/requests';
import { fetchFavorites, paginationLimit } from './fetch-favorites';
import { useInfiniteQuery } from 'react-query';

/**
 * Export `InitialData` type.
 */

export type InitialData = {
  pageParams: number[];
  pages: Array<{
    data: FavoriteProps[];
    nextPage: number | null;
    total: number;
  }>;
};

/**
 * `Options` type.
 */

type Options = {
  enabled?: boolean;
  initialData?: InitialData | null;
  limit?: number;
  token: Token;
};

/**
 * Action type.
 */

const actionType = 'favorites';

/**
 * `useFavorites` hook.
 */

function useFavorites(options?: Options) {
  const { initialData, limit, token } = options;
  const result = useInfiniteQuery(
    actionType,
    ({ pageParam = 1 }) =>
      fetchFavorites({
        params: {
          limit: limit ?? paginationLimit,
          page: pageParam
        },
        token
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const pageLimit = Math.ceil(allPages[0]?.total / paginationLimit);
        const nextPage = lastPage?.nextPage;

        return nextPage <= pageLimit ? nextPage : false;
      },
      initialData
    }
  );

  return result;
}

/**
 * Export `useFavorites` hook.
 */

export default useFavorites;
